/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 *
 * H1 opcional en el cuerpo. Tabs y Shell usan el header operativo; este componente
 * queda para pantallas embebidas / casos que aún lo pidan.
 */
import React from 'react';
import { StyleSheet, Text, View, type StyleProp, type ViewStyle } from 'react-native';
import { spacing } from '../../shared/theme/spacing';
import { ticketColors, ticketFonts } from '../../shared/theme/ticketColors';

type ScreenPageTitleProps = {
  title: string;
  style?: StyleProp<ViewStyle>;
  /** Densidad menor (p. ej. POS). */
  compact?: boolean;
};

export function ScreenPageTitle({ title, style, compact = false }: ScreenPageTitleProps) {
  return (
    <View style={[styles.wrap, compact && styles.wrapCompact, style]} accessibilityRole="header">
      <Text style={[styles.title, compact && styles.titleCompact]} numberOfLines={2}>
        {title}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    paddingHorizontal: spacing.md,
    paddingTop: spacing.sm,
    paddingBottom: spacing.xs,
    flexShrink: 0,
  },
  wrapCompact: {
    paddingTop: spacing.xs,
    paddingBottom: 2,
  },
  title: {
    color: ticketColors.ink,
    fontSize: 22,
    lineHeight: 28,
    fontWeight: '800',
    fontFamily: ticketFonts.sans,
    letterSpacing: -0.3,
  },
  titleCompact: {
    fontSize: 18,
    lineHeight: 22,
  },
});
